import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";
import type { CategoryCalloutBlock as CategoryCalloutBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "../../styles/composable/category-callout.module.scss";

type IPillowsImage =
    templates.PillowsLandingPageTemplate["category_callout_ssr"][string][number];

type IProps = Immutable<{
    value: CategoryCalloutBlockValue;
    images: IPillowsImage[];
}>;

/**
 * The PillowsLandingPage ``category_callout_block``. The ``--pillows`` literals
 * stay on the markup: ``pages/pillows-landing.scss`` selects them.
 */
export const PillowsCategoryCallout = (props: IProps): React.JSX.Element => {
    return (
        <section
            className={concatClassNames([
                styles.categoryCallout,
                "category-callout",
                "l-capped-width",
                "u-margin-bottom--xl",
            ])}
        >
            <div className={styles.categoryCalloutCopy}>
                <h3
                    className={concatClassNames([
                        styles.categoryCalloutTitle,
                        "category-callout__title--pillows",
                    ])}
                >
                    {props.value.headline}
                </h3>
                <div className={styles.categoryCalloutDescription}>
                    {props.value.description}
                </div>
            </div>
            <ul
                className={concatClassNames([
                    styles.categoryCalloutList,
                    styles.categoryCalloutListPillows,
                    "category-callout-list--pillows",
                ])}
            >
                {(props.value.category_list ?? []).map((item, i) => {
                    const linkURL = item.link?.url ?? "";
                    const image = props.images.at(i);
                    return (
                        <li
                            key={i}
                            className={concatClassNames([
                                styles.categoryCalloutListItem,
                                styles.categoryCalloutListItemPillows,
                                "category-callout-list__item--pillows",
                            ])}
                        >
                            <div
                                className={concatClassNames([
                                    styles.categoryCalloutListImageContainer,
                                    styles.categoryCalloutListImageContainerPillows,
                                    "category-callout-list__image-container--pillows",
                                ])}
                            >
                                <a href={linkURL}>
                                    {image?.url && (
                                        <img
                                            src={image.url}
                                            className="responsive-img"
                                            alt={image.alt}
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    )}
                                </a>
                            </div>
                            <a href={linkURL}>
                                <h4>{item.copy}</h4>
                            </a>
                        </li>
                    );
                })}
            </ul>
            <a href={props.value.shop_link?.url ?? ""} className="button">
                {props.value.shop_link_name}
            </a>
        </section>
    );
};
